import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'badgePipe', standalone: true })
export class BadgePipe implements PipeTransform {
  transform(qty: number, prefix = '+', max = 99): string {
    if (qty) {
      if (qty <= 0) {
        return '';
      }
      if (qty > 99) {
        return prefix + max;
      }
      return qty.toString();
    } else {
      return '';
    }
  }
}
